import { GroupDescriptor } from '@progress/kendo-data-query';
import { WidgetID } from './widget.model';

export interface PersistedColumnSelection {
  title: string;
}

export interface PersistedColumnOrder {
  id: string;
  hidden?: boolean;
}

// Column order can be either:
// - Legacy format: number[] (indices, for backward compatibility)
// - New format: PersistedColumnOrder[] (named references with optional hidden state)
export type ColumnOrderType = number[] | PersistedColumnOrder[];

export function isNamedColumnOrder(
  columnOrder: ColumnOrderType | undefined
): columnOrder is PersistedColumnOrder[] {
  if (!columnOrder || columnOrder.length === 0) return false;
  return typeof columnOrder[0] === 'object' && 'id' in columnOrder[0];
}

export interface GridConfig {
  columnOrder?: ColumnOrderType;
  group?: GroupDescriptor[];
  selectedColumns?: PersistedColumnSelection[];
}

export interface GridConfigUserData {
  key: number;
  data: GridConfigDictionary;
}

export interface GridConfigDictionary {
  [key: WidgetID]: GridConfig;
}

export interface GridGroupActionPayload {
  id: WidgetID;
  group: GroupDescriptor[];
}

export type KwelloBryntumCellType =
  | 'activeStatus'
  | 'alignmentChange'
  | 'alignmentLabel'
  | 'attachment'
  | 'categoryQuestionNameWithFilter'
  | 'count'
  | 'date'
  | 'default'
  | 'fractionBar'
  | 'profile'
  | 'questionDetailsButton'
  | 'sparkline'
  | 'tags'
  | 'teamMember';
